import React from "react";
import { EditNakiStoreFeaturedSectionContentTemplate } from "themes/administration/naki-store/components";
import { EditNakiStoreFeaturedSectionContentViewStore } from "administration/naki-store/stores";
import { setCurrentView } from "mrb/core";

@setCurrentView(
    (rootStore, componentProps) => new EditNakiStoreFeaturedSectionContentViewStore(rootStore, componentProps),
    "editNakiStoreFeaturedSectionContentViewStore"
)
class EditNakiStoreFeaturedSectionContent extends React.Component {
    render() {
        return <EditNakiStoreFeaturedSectionContentTemplate {...this.props} />;
    }
}

export default EditNakiStoreFeaturedSectionContent;
